import React from 'react';
import { classNames } from './classNames';
import { ButtonVariant } from './Button';

export interface SpinnerProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'div' | 'span';
  variant?: ButtonVariant;
  size?: 'sm';
  label?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  as: Component = 'div',
  variant = 'primary',
  size,
  label = 'Chargement...',
  className,
  ...props
}) => (
  <Component
    className={classNames(
      'spinner-border',
      `text-${variant}`,
      size ? `spinner-border-${size}` : undefined,
      className,
    )}
    role="status"
    {...props}
  >
    <span className="visually-hidden">{label}</span>
  </Component>
);

export default Spinner;
